import MobileNavMenu from '@/components/header/nav-menu/MobileNavMenu';
import RegularNavMenu from '@/components/header/nav-menu/RegularNavMenu';
import { resetChangeTripsSelection } from '@/features/manage/manageActions';
import { resetPurchase } from '@/features/purchase/purchaseActions';
import { useSearchWidget } from '@/hooks/useSearchWidget';
import { TransText, type TransTextKeys } from '@/i18n/trans/text';
import { persistor } from '@/store';
import { useDispatch } from '@/store/utils';
import type { NavigationItem } from '@/types/navigation';
import { breakpoints } from '@/utils/breakpoints';
import { Icons } from '@fleet/webshop-ui';
import type { FC, ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

const Header: FC = () => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });
  const dispatch = useDispatch();
  const { setCurrentSearchFormValues } = useSearchWidget();

  const menuItems: Array<NavigationItem> = [
    {
      path: '/purchase',
      name: <TransText i18nKey="purchase" />,
      testId: 'purchase',
      // "Start a clean purchase" — abandon any in-progress change-booking
      // flow AND any in-progress regular purchase. Clears redux on both
      // sides (purchase slice + change-trips selection), drops the
      // search-widget context, and purges the persisted store so a refresh
      // doesn't re-hydrate stale journeys / passenger refs / booking ID.
      onClick: () => {
        dispatch(resetPurchase());
        dispatch(resetChangeTripsSelection());
        setCurrentSearchFormValues(undefined);
        void persistor.purge();
      },
    },
    {
      path: '/manage-booking',
      name: <TransText i18nKey="manageBooking" />,
      testId: 'manage-booking',
    },
  ];

  const userMenuItems: Array<[TransTextKeys, string, ReactNode]> = [
    ['tickets', '/account/tickets', <Icons.ticket height={20} width={20} />],
    [
      'travelPasses',
      '/account/travel-passes',
      <Icons.travelPass height={20} width={20} />,
    ],
    ['vouchers', '/account/vouchers', <Icons.wallet height={20} width={20} />],
    [
      'accountDetails',
      '/account/details',
      <Icons.user height={20} width={20} />,
    ],
    ['logOut', 'logout', <Icons.logOut height={20} width={20} />],
  ];

  const NavMenu = isLaptopOrBigger ? RegularNavMenu : MobileNavMenu;

  return (
    <header className="flex w-full flex-shrink-0 items-center border-b border-neutral-light bg-white text-dark">
      <div className="mx-auto w-full max-w-laptop px-4 py-2">
        <NavMenu menuItems={menuItems} userMenuItems={userMenuItems} />
      </div>
    </header>
  );
};

export default Header;
